import { ContentCard } from '@innovyze/stylovyze';
import {
	ALL_ENTITLEMENTS,
	ALL_ROLES,
	ROWS_PER_PAGE,
	UserParams,
	UserTableSelection,
} from '@Types';
import { SubscriptionsValueKeyMap } from '@Types/entitlements.types';
import React, { useState } from 'react';
import EntitlementsTableBody from './EntitlementsTableBody';
import EntitlementsTableFooter from './EntitlementsTableFooter';
import EntitlementsTableHeader from './EntitlementsTableHeader';
import { TFunc, useGlobalization } from '@Translations';

const EntitlementsTable = () => {
	const [selectedLimitIndex, setSelectedLimitIndex] = useState(1);
	const { t } = useGlobalization();
	const [userTableSelection, setUserTableSelection] =
		React.useState<UserTableSelection>({
			role: ALL_ROLES,
			entitlement: ALL_ENTITLEMENTS,
			search: '',
		});

	const createGetUsersRequest = (
		userTableSelectionState: UserTableSelection,
		t: TFunc,
	) => {
		let getUserRequest: UserParams = {
			pageSize: ROWS_PER_PAGE[selectedLimitIndex],
			page: 1,
			queryString: userTableSelectionState.search,
		};
		if (userTableSelectionState.entitlement != ALL_ENTITLEMENTS) {
			getUserRequest = {
				...getUserRequest,
				entitlement: SubscriptionsValueKeyMap(t).get(
					userTableSelectionState.entitlement,
				),
			};
		}
		if (userTableSelectionState.role != ALL_ROLES) {
			getUserRequest = {
				...getUserRequest,
				role: userTableSelectionState.role,
			};
		}
		return getUserRequest;
	};

	const header = (
		<EntitlementsTableHeader
			setUserTableSelection={setUserTableSelection}
			userTableSelection={userTableSelection}
			createGetUsersRequest={value => createGetUsersRequest(value, t)}
		/>
	);
	const tableFooter = (
		<EntitlementsTableFooter
			userTableSelection={userTableSelection}
			selectedLimitIndex={selectedLimitIndex}
			setSelectedLimitIndex={setSelectedLimitIndex}
			createGetUsersRequest={value => createGetUsersRequest(value, t)}
		/>
	);
	return (
		<ContentCard
			applyBodyPadding={false}
			header={header}
			footer={tableFooter}>
			<EntitlementsTableBody
				rowCount={ROWS_PER_PAGE[selectedLimitIndex]}
			/>
		</ContentCard>
	);
};

export default EntitlementsTable;
